import { render, staticRenderFns } from "./SidebarTabExternalActionLegacy.vue?vue&type=template&id=a237aed4"
import script from "./SidebarTabExternalActionLegacy.vue?vue&type=script&lang=js"
export * from "./SidebarTabExternalActionLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports